const FOUNDERS_FEEDBACK_STRINGS = {
  promptLead: 'We’re building Belong for\u00a0you.',
  promptQuestion: 'Have feedback for\u00a0us?',
  cta: 'Message The Founders'
};
const FOUNDERS_EMAIL = 'mailto:founders@belonghome.com';

export { FOUNDERS_EMAIL, FOUNDERS_FEEDBACK_STRINGS };
